import Vue from "vue";

import { Component } from "@/decorators";
import VendaModel from "@/models/vendaModel";
import VendaService from "@/services/vendaService";

@Component({})
export default class AdicionarVendaComponent extends Vue {
    vendaService = new VendaService();
    private codigoVenda = "";

    public async buscarVenda() {
        const venda = await this.vendaService
            .getByCodigoFromNotaFiscalServico(this.codigoVenda)
            .withLoading()
            .resolveWithJSON<VendaModel>();

        if (venda == null) {
            await this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.pesqNaoEncResul"));
            return;
        }

        this.codigoVenda = "";
        this.$emit("adicionar-itens", venda);
    }
}
